import React from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface SchemaStabilitySectionProps {
  schemaStabilityScore: number
  schemaStabilityChartData: any[]
  isSchemaLoading: boolean
  schemaTimeRange: 'week' | 'month' | 'quarter' | 'year'
  handleSchemaTimeRangeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const SchemaStabilitySection: React.FC<SchemaStabilitySectionProps> = ({
  schemaStabilityChartData,
  isSchemaLoading,
  schemaTimeRange,
  handleSchemaTimeRangeChange
}) => {
  return (
    
     

      <div className="stability-trend-section">
        <div className="stability-trend-header">
          <h2 className="stability-trend-title">Pipeline success</h2>
          <div className="time-range-selector">
            <select className="time-range-dropdown" value={schemaTimeRange} onChange={handleSchemaTimeRangeChange}>
              <option value="week">Last week</option>
              <option value="month">Last month</option>
              <option value="quarter">Last quarter</option>
              <option value="year">Last year</option>
            </select>
          </div>
        </div>

        <div className="recharts-container">
          {isSchemaLoading ? (
            <div style={{ height: 250, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              Loading chart...
            </div>
          ) : (
            <ResponsiveContainer width="100%" height={250}>
              <AreaChart
                data={schemaStabilityChartData.length > 0 ? schemaStabilityChartData : [{ time: 'No data', value: 0 }]}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
              >
              <defs>
                <linearGradient id="colorSchemaStability" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#86efac" stopOpacity={0.4}/>
                  <stop offset="95%" stopColor="#86efac" stopOpacity={0.05}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis
                dataKey="time"
                stroke="#9ca3af"
                style={{ fontSize: '12px' }}
                tick={{ fill: '#6b7280' }}
              />
              <YAxis
                domain={[90, 100]}
                stroke="#9ca3af"
                style={{ fontSize: '12px' }}
                tick={{ fill: '#6b7280' }}
                tickFormatter={(value) => `${value}%`}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  fontSize: '12px',
                  padding: '8px 12px'
                }}
                formatter={(value: any) => typeof value === 'number' ? [`${value.toFixed(1)}%`, 'Stability'] : ['', '']}
                labelStyle={{ color: '#111827', fontWeight: 600 }}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke="#22c55e"
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorSchemaStability)"
                animationDuration={1500}
                dot={{ r: 4, fill: '#22c55e', strokeWidth: 0 }}
                activeDot={{ r: 6, fill: '#22c55e' }}
              />
            </AreaChart>
          </ResponsiveContainer>
          )}
        </div>
      </div>
    
  )
}

export default SchemaStabilitySection